import React, { useState } from 'react';
import cataloguesPost from '../../api/cataloguesPost';
import useCatalogues from '../../api/cataloguesGet';
import LogOut from '../../containers/LogOut';

export default () => {
  const [title, setTitle] = useState('');
  const [newCat, setNewCat] = useState('');
  const [error, setError] = useState('');
  const catalogues = useCatalogues(newCat);
  const handleNewCatalogue = (e) => {
    e.preventDefault();
    if (title.length < 2) {
      setError('Title must include more characters than two');
    } else {
      setError('');
      cataloguesPost(title).then(() => setNewCat(title));
    }
  };
  return (
    <div className="lightbox">
      <LogOut />
      <form className="lightbox_form" onSubmit={(e) => handleNewCatalogue(e)}>
        <input
          className="lightbox_form_field"
          type="text"
          placeholder="Title"
          name="title"
          onChange={(e) => setTitle(e.target.value)}
        />
        <button type="submit" className="lightbox_form_box">
          Create new ligthbox
        </button>
      </form>
      <p className="lightbox_error">{error}</p>
      {catalogues}
    </div>
  );
};
